import sha from "sha.js";

export default (data, enc) => {
  return sha("sha256")
    .update(data, enc)
    .digest("hex");
};
